"use strict";

/* Delivery date selector logic - cart-drawer.liquid */
(() => {
  const cartDrawerSection = document.querySelector(
    ".shopify-section--cart-drawer"
  );
  if (!cartDrawerSection) return;

  const deliveryDateContainer = cartDrawerSection.querySelector(
    ".show-delivery-date-container"
  );
  const deliveryDateSelect = deliveryDateContainer.querySelector("select");
  const checkoutButton = cartDrawerSection.querySelector("[name='checkout']");
  if (!deliveryDateContainer || !deliveryDateSelect || !checkoutButton) return;

  document.addEventListener("DOMContentLoaded", () => {
    validateDeliveryDate();
  });

  cartDrawerSection.addEventListener("click", (event) => {
    const eventPath = event.composedPath
      ? event.composedPath().slice(0, -2)
      : [];

    for (const element of eventPath) {
      const clickAction = element.dataset.clickAction;
      if (!clickAction) continue;

      if (clickAction === "go-to-checkout") {
        onCheckoutButtonClick(element, event);
        break;
      }
    }
  });

  cartDrawerSection.addEventListener("change", async (event) => {
    const eventPath = event.composedPath
      ? event.composedPath().slice(0, -2)
      : [];

    for (const element of eventPath) {
      const changeAction = element.dataset.changeAction;
      if (!changeAction) continue;

      if (changeAction === "update-delivery-date") {
        event.preventDefault();
        await onDeliveryDateChange();
        break;
      }
    }
  });

  function validateDeliveryDate() {
    if (!checkoutButton.hasAttribute("data-disabled")) return;

    const selectedDeliveryDateString =
      deliveryDateContainer.dataset.deliveryDate;

    const currentDeliveryDateValue = deliveryDateSelect.value;
    let newDeliveryDateValue = currentDeliveryDateValue;

    const selectedDeliveryDate = new Date(selectedDeliveryDateString);
    const nextAvailableDeliveryDate = getNextAvailableDeliveryDate();

    if (selectedDeliveryDate > nextAvailableDeliveryDate) {
      newDeliveryDateValue = selectedDeliveryDateString;
    } else if (
      selectedDeliveryDateString === "" ||
      selectedDeliveryDate <= nextAvailableDeliveryDate
    ) {
      disableCheckoutButton();
      newDeliveryDateValue = "";
    }

    deliveryDateSelect.value = newDeliveryDateValue;
    if (newDeliveryDateValue === currentDeliveryDateValue) {
      deliveryDateSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function onCheckoutButtonClick(checkoutButton, event) {
    if (checkoutButton.hasAttribute("data-disabled")) {
      event.preventDefault();
      disableCheckoutButton(true);

      const animationContainer = deliveryDateContainer.parentElement;
      animationContainer.classList.add("flash-animation");
      animationContainer.addEventListener(
        "animationend",
        () => {
          animationContainer.classList.remove("flash-animation");
        },
        { once: true }
      );
    }
  }

  async function onDeliveryDateChange() {
    let deliveryDateValue = deliveryDateSelect.value;
    if (deliveryDateValue === "") {
      deliveryDateValue = null;
    }

    try {
      checkoutButton.setAttribute("inert", "");

      const cartUpdateJson = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            deliveryDate: deliveryDateValue,
          },
        }),
      });

      const cartJson = await fetch("/cart.js")
        .then((response) => response.json())
        .then((json) =>
          json.items.forEach((item) => {
            const { key } = item;

            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: key,
                properties: {
                  deliveryDate: deliveryDateValue,
                },
              }),
            });
          })
        );

      if (deliveryDateValue === null) {
        disableCheckoutButton();
      } else if (checkoutButton.hasAttribute("data-disabled")) {
        enableCheckoutButton();
      }
    } catch (error) {
      console.error("Error updating cart delivery date", error);
    } finally {
      checkoutButton.removeAttribute("inert");
    }
  }

  function disableCheckoutButton(showMessage) {
    showMessage
      ? checkoutButton.setAttribute("data-disabled", "message")
      : checkoutButton.setAttribute("data-disabled", "");
  }
  function enableCheckoutButton() {
    checkoutButton.removeAttribute("data-disabled");
  }

  function getNextAvailableDeliveryDate() {
    // Get current date in UTC+1 (Bern/Zurich timezone)
    const storeDate = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Zurich" })
    );
    const storeHour = storeDate.getHours();

    let nextDate = new Date(storeDate);
    nextDate.setDate(storeDate.getDate() + 1);

    if (storeHour >= 18) {
      removeNextDayFromDeliveryDateSelector(nextDate);
      nextDate.setDate(nextDate.getDate() + 1);
    }

    while (!isValidDeliveryDay(nextDate)) {
      nextDate.setDate(nextDate.getDate() + 1);
    }

    nextDate.setHours(0, 0, 0, 0);

    return nextDate;

    function isValidDeliveryDay(date) {
      const day = date.getDay();

      // Valid days are Tuesday (2) through Friday (5)
      return day >= 2 && day <= 5;
    }

    function removeNextDayFromDeliveryDateSelector(date) {
      const targetValue = getDeliveryDateString(date);

      const targetOption = deliveryDateContainer.querySelector(
        `option[value="${targetValue}"]`
      );

      if (!targetOption) return;

      targetOption.remove();
    }
  }

  function getDeliveryDateString(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  }
})();
